import createVueComponent from '../createVueComponent';

const Crop = createVueComponent('CropIcon', [
  ['path', { d: 'M6.13 1L6 16a2 2 0 002 2h15' }],
  ['path', { d: 'M1 6.13L16 6a2 2 0 012 2v15' }],
]);

export default Crop;
